// TEST environment: points at the separate Firebase TEST project, never at
// reserve-it-cee02 (production). See docs/TEST-ENVIRONMENT-SETUP.md.
export const environment = {
  production: false,
  useEmulators: false,
  // Sign a visitor in as the seeded admin so the test site can be reviewed without
  // typing credentials on every visit. ONLY on this build: environment.ts (production)
  // and environment.emulator.ts do not carry the flag, and auth.service.ts also refuses
  // to act on it unless the project id is literally reserve-it-test. Logging out stays
  // logged out for the rest of the browser session.
  autoLoginAdmin: {
    email: 'admin@spinningwesterlo.test',
    password: 'secretwesterlo',
  },
  firebase: {
    projectId: 'reserve-it-test',
    appId: '1:346403011681:web:d265f3f924ae199ccdbe20',
    storageBucket: 'reserve-it-test.firebasestorage.app',
    locationId: 'europe-west',
    apiKey: 'AIzaSyCgxeMBHz9CV0CYhEcsw9qKt8RDP90FXJU',
    authDomain: 'reserve-it-test.firebaseapp.com',
    messagingSenderId: '346403011681',
  },
};
